import React from 'react';


const NewButton = ({ className, iconClass, icon, onClick, notext, children, iconRight = false, textClass}) => {
    return(
        <>
            <button 
                className={`d-flex justify-content-center align-items-center ${className ? className : ""} btn`} 
                onClick={onClick}
            >
                {icon && !iconRight && 
                    <img className={`${iconClass ?? ""} ${!notext ? "justify-self-start me-1" : ""}`} 
                    src={icon} 
                    alt={"..."}
                />}
                <label className={`cursor-pointer ${notext ? "d-none" : ""} d-flex justify-content-center align-items-center w-100 ${textClass ?? ""}`}>
                    {icon && '\u00A0'}
                    {children}
                </label>
                {icon && iconRight && 
                    <img className={`${iconClass ?? ""}`} 
                    src={icon} 
                    alt={"..."}
                />}    
            </button>
        </>
    )
}

export default NewButton;